module.exports = __webpack_public_path__ + "img/nodisk.e220b47f.png";